// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bde80d0f","453":"2c2f6ed7","455":"e76dd64e","977":"6c7a7ea8"}[chunkId] + ".chunk.js";
};